import React from "react";
import CustomInput from "../../../../../../../Components/CustomInputs/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";

const DeathTimeOfClaimField: React.FC = () => {
   const dispatch = useDispatch();

   const TimeOfClaimValueDeath = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 6
         )?.timeOfClaim
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   return (
      <CustomInput
         labelText="Čas škody"
         name="TimeOfClaim"
         value={TimeOfClaimValueDeath || ""}
         onChange={(e) => {
            dispatch(
               updateFirstStepDynamicFields({
                  value: e.target.value,
                  field: "timeOfClaim",
                  typeOfClaimEnum: 6,
               })
            );
         }}
         validationText={handleShowErrorMessage(
            "death.TimeOfClaim",
            claimFieldErrorsMessages
         )}
         placeholderText=""
         dependencyValue={shouldRenderSpecField(
            "death",
            "TimeOfClaim",
            visibilityMatrixes
         )}
      />
   );
};

export default DeathTimeOfClaimField;
